<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="row g-6">
      <!-- Card Border Shadow -->
      <a
        href="/"
        class="col-lg-4 col-sm-6"
        v-if="
          hasPrivilege('dashboard_view_statistics') &&
            hasPrivilege('cards_view_index_cards') &&
            hasPrivilege('accounts_view_index_accounts')
        "
      >
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.total_users") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.total_users
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.user")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <i class="ti ti-users ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="$router.push({ name: 'Accounts' })"
        href="/accounts"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.total_accounts") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.total_accounts
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.account")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <i class="ti ti-users-group ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="$router.push({ name: 'Cards' })"
        href="/cards"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.total_cards") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.total_cards
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.card")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <i class="ti ti-cards ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>

      <a
        @click.prevent="
          $router.push({ name: 'Accounts', query: { type: 'online' } })
        "
        href="/accounts?type=online"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-info h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-info-color">
                {{ $t("dashboard.statistics.online_accounts") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.online_accounts
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.account")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-info rounded p-2">
                <i class="ti ti-user-check ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="
          $router.push({ name: 'Cards', query: { type: 'online' } })
        "
        href="/cards?type=online"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-info h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-info-color">
                {{ $t("dashboard.statistics.online_cards") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.online_cards
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.card")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-info rounded p-2">
                <i class="ti ti-checkbox ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="$router.push({ name: 'OnlineSessions' })"
        href="/sessions/online"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-info h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-info-color">
                {{ $t("dashboard.statistics.online_sessions") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.total_online
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.session")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-info rounded p-2">
                <i class="ti ti-power ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>

      <a
        @click.prevent="
          $router.push({ name: 'Accounts', query: { type: 'expired' } })
        "
        href="/accounts?type=expired"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-danger h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-danger-color">
                {{ $t("dashboard.statistics.expired_accounts") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.expired_accounts
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.account")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-danger rounded p-2">
                <i class="ti ti-user-x ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="
          $router.push({ name: 'Accounts', query: { type: 'expiring' } })
        "
        href="/accounts?type=expiring"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-warning h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-warning-color">
                {{ $t("dashboard.statistics.accounts_expiring_soon") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.expiring_accounts
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.account")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-warning rounded p-2">
                <i class="ti ti-alert-octagon ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="
          $router.push({
            name: 'Accounts',
            query: { type: 'expiration_profile' },
          })
        "
        href="/accounts?type=expiration_profile"
        class="col-lg-4 col-sm-6"
        v-if="hasPrivilege('dashboard_view_statistics')"
      >
        <div class="card card-border-shadow-warning h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-warning-color">
                {{ $t("dashboard.statistics.accounts_at_expiration_profile") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.expiration_profile_accounts
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.account")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-warning rounded p-2">
                <i class="ti ti-user-exclamation ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="$router.push({ name: 'Support' })"
        href="/support"
        class="col-lg-4 col-sm-6"
        v-if="
          hasPrivilege('dashboard_view_statistics') &&
            hasPrivilege('support_tickets_view_index_support_tickets') &&
            settings.features.ssra
        "
      >
        <div class="card card-border-shadow-warning h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-warning-color">
                {{ $t("dashboard.statistics.support_tickets") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.support_tickets
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.ticket")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-warning rounded p-2">
                <i class="ti ti-lifebuoy ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="$router.push({ name: 'Profiles' })"
        href="/profiles"
        class="col-lg-4 col-sm-6"
        v-if="
          user.type != 'reseller' &&
            hasPrivilege('dashboard_view_statistics') &&
            hasPrivilege('profiles_view_index_profiles')
        "
      >
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.profiles") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.profiles
                }}</span>
                <small class="text-muted card-2-text">{{
                  $t("dashboard.statistics.profile")
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <i class="ti ti-brand-speedtest ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>
      <a
        @click.prevent="
          $router.push({ name: 'Accounts', query: { type: 'in_debt' } })
        "
        href="/accounts?type=in_debt"
        class="col-lg-4 col-sm-6"
        v-if="user.type != 'reseller' && hasPrivilege('system_ownership')"
      >
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.total_debt") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  dash.total_debts
                }}</span>
                <small class="text-muted card-2-text">{{
                  settings.currency
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <i class="ti ti-moneybag ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </a>

      <div class="col-lg-4 col-sm-6" v-if="user.type == 'reseller'">
        <div class="card card-border-shadow-success h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-success-color">
                {{ $t("dashboard.statistics.money") }}
              </p>
              <p class="mb-0">
                <span class="text-heading fw-medium me-2 card-1-text">{{
                  user.money
                }}</span>
                <small class="text-muted card-2-text">{{
                  settings.currency
                }}</small>
              </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-success rounded p-2">
                <i class="ti ti-cash ti-48px"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <a class="col-lg-4 col-sm-6 cursor-pointer" v-if="user.type != 'reseller' && hasPrivilege('accounting_view_bills')" @click.prevent="
          $router.push({
            name: 'Bills',
            query: { type: 'shamcash' },
          })
        ">
        <div class="card card-border-shadow-primary h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <p class="mb-1 card-main-text card-primary-color">
                {{ $t("dashboard.statistics.shamcash_bills") }}
              </p>
              <p class="mb-0">
              <span class="text-heading fw-medium me-2 card-1-text">{{
                dash.today_shamcash.toFixed(2)
              }}</span>
              <small class="text-muted card-2-text">{{
                settings.currency
              }}</small>
              <small class="text-muted card-2-text">{{ $t("dashboard.statistics.today") }}</small>
            </p>
            <p class="mb-0">
              <span class="text-heading fw-medium me-2 card-1-text">{{
                dash.total_shamcash.toFixed(2)
              }}</span>
              <small class="text-muted card-2-text">{{
                settings.currency
              }}</small>
              <small class="text-muted card-2-text">{{ $t("dashboard.statistics.month") }}</small>
            </p>
            </div>

            <div class="card-icon">
              <span class="badge bg-label-primary rounded p-2">
                <!-- <i class="ti ti-cash ti-48px"></i> -->
                <img src="@/assets/shamcash_logo.svg" class="h-12 w-12" alt="" />
              </span>
            </div>
          </div>
        </div>
      </a>

      <div class="col-lg-4 col-sm-6"></div>
      <div class="col-lg-4 col-sm-6"></div>

      <!--/ Card Border Shadow -->

      <div
        v-if="
          hasPrivilege('dashboard_view_statistics')
        "
        class="col-lg-6"
        style="min-height: 18em;"
      >
        <div class="card h-100">
          <div class="card-body row overflow-auto" style="height: 160px;">
            <div class="row">
              <div class="col-12 row">
                <div class="col-12 col-md-6 flex align-items-center">
                <select class="form-select" v-model="payments_filter" @change="fetch_payments">
                  <option value="day">{{ $t('dashboard.earnings.today_earnings') }}</option>
                  <option value="week">{{ $t('dashboard.earnings.week_earnings') }}</option>
                  <option value="month">{{ $t('dashboard.earnings.month_earnings') }}</option>
                  <option value="year">{{ $t('dashboard.earnings.year_earnings') }}</option>
                </select>
              </div>
              </div>
              <div class="col-12 flex align-items-center gap-2">
                <span
                  class="rounded-md bg-green-200 text-green-600 py-1 px-4"
                  ><i class="me-1">{{ $t('dashboard.earnings.earnings') }}</i>{{
                    payments_loading == false ? parseFloat(payments.grand_total).toFixed(2) +
                      " " +
                      settings.currency :"..."
                  }}</span
                >
                <span
                  class="rounded-md bg-red-200 text-red-600 py-1 px-4"
                  ><i class="me-1">{{ $t('dashboard.earnings.debts') }}</i>{{
                    payments_loading == false ? parseFloat(payments.grand_total_debt).toFixed(2) +
                      " " +
                      settings.currency :"..."
                  }}</span
                >
              </div>
              <!-- <hr /> -->
              <div class="col-12">
                <table class="dt-scrollableTable table">
                  <thead style="background-color: var(--bs-card-bg);">
                    <tr class="text-nowrap">
                      <th class="p-0 py-2"></th>
                      <th class="p-0 py-2">{{ $t('dashboard.earnings.amount_paid') }}</th>
                      <th class="p-0 py-2">{{ $t('dashboard.earnings.amount_debt') }}</th>
                      <th class="p-0 py-2">{{ $t('dashboard.earnings.bills_count') }}</th>
                    </tr>
                  </thead>
                  <tbody class="table-border-bottom-0">
                    <tr>
                      <th class="p-0">{{ $t('dashboard.earnings.my_earnings') }}</th>
                      <td class="p-0">
                        {{ parseFloat(payments.total_me).toFixed(2) }}
                      </td>
                      <td class="p-0">{{ parseFloat(payments.total_me_debt).toFixed(2) }}</td>
                      <td class="p-0">{{ payments.count_me }}</td>
                    </tr>
                    <tr>
                      <th class="p-0">{{ $t('dashboard.earnings.admins') }}</th>
                      <td class="p-0">
                        {{ parseFloat(payments.total_admins).toFixed(2) }}
                      </td class="p-0">
                      <td class="p-0">{{ parseFloat(payments.total_admins_debt).toFixed(2) }}</td>
                      <td class="p-0">{{ payments.count_admins }}</td>
                    </tr>
                    <tr>
                      <th class="p-0">{{ $t('dashboard.earnings.resellers') }}</th>
                      <td class="p-0">
                        {{ parseFloat(payments.total_resellers).toFixed(2) }}
                      </td class="p-0">
                      <td class="p-0">{{ parseFloat(payments.total_resellers_debt).toFixed(2) }}</td>
                      <td class="p-0">{{ payments.count_resellers }}</td>
                    </tr>
                    <tr>
                      <th class="p-0">{{ $t('dashboard.earnings.shamcash') }}</th>
                      <td class="p-0">
                        {{ parseFloat(payments.total_shamcash).toFixed(2) }}
                      </td class="p-0">
                      <td class="p-0">{{ parseFloat(payments.total_shamcash_debt).toFixed(2) }}</td>
                      <td class="p-0">{{ payments.count_shamcash }}</td>
                    </tr>
                    <tr>
                      <th class="p-0">{{ $t('dashboard.earnings.app_money') }}</th>
                      <td class="p-0">
                        {{ parseFloat(payments.total_app).toFixed(2) }}
                      </td>
                      <td class="p-0">{{ parseFloat(payments.total_app_debt).toFixed(2) }}</td>
                      <td class="p-0">{{ payments.count_app }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
            <div
        class="col-lg-6"
        v-if="
          hasPrivilege('dashboard_view_statistics') &&
            this.settings.sessions.available > 0 &&
            user.type != 'reseller'
        "
      >
        <div class="card h-100">
          <div
            class="card-header d-flex align-items-center justify-content-between"
          >
            <div class="card-title mb-0">
              <h5 class="m-0 me-2">
                {{ $t("dashboard.statistics.remaining_sessions") }}
              </h5>
            </div>
          </div>
          <div class="card-body">
            <div class="d-none d-lg-flex vehicles-progress-labels mb-6">
              <div
                class="vehicles-progress-label on-the-way-text"
                style="width: 39.7%"
              >
                {{ $t("dashboard.statistics.remaining_sessions") }} <br />
                {{ sessions.remaining >= 0 ? sessions.remaining : 0 }}
              </div>
              <div
                class="vehicles-progress-label unloading-text"
                style="width: 28.3%"
              >
                {{ $t("dashboard.statistics.online_sessions") }}<br />
                {{ sessions.online }}
              </div>
            </div>
            <div
              class="vehicles-overview-progress progress rounded-3 mb-6"
              style="height: 46px"
              v-if="sessions.remaining > 0"
            >
              <div
                class="progress-bar fw-medium text-start bg-lighter text-dark px-4 rounded-0"
                role="progressbar"
                :style="{
                  width: `${(sessions.remaining * 100) / sessions.available}%`,
                }"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ parseInt((sessions.remaining * 100) / sessions.available) }}%
              </div>
              <div
                class="progress-bar fw-medium text-start px-1 px-sm-3 rounded-0 px-lg-4"
                role="progressbar"
                :style="{
                  width: `${(sessions.online * 100) / sessions.available}%`,
                }"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ parseInt((sessions.online * 100) / sessions.available) }}%
              </div>
            </div>
            <div
              v-else
              class="vehicles-overview-progress progress rounded-3 mb-6"
              style="height: 46px"
            >
              <div
                class="progress-bar fw-medium text-start bg-danger text-dark px-4 rounded-3"
                role="progressbar"
                :style="{
                  width: `100%`,
                }"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ parseInt((sessions.online * 100) / sessions.available) }}%
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div
        v-if="
          hasPrivilege('dashboard_view_statistics') && user.type != 'reseller'
        "
        :class="{
          'col-lg-6':
            hasPrivilege('dashboard_view_statistics') &&
            this.settings.sessions.available > 0,
          'col-lg-12':
            !hasPrivilege('dashboard_view_statistics') ||
            this.settings.sessions.available <= 0,
        }"
      >
        <div class="card h-100">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <h5 class="m-0 me-2">
                {{ $t("dashboard.statistics.online") }}
              </h5>
            </div>
          </div>
          <div class="card-body">
            <div id="OnlineAccounts"></div>
          </div>
        </div>
      </div>

      <div
        v-if="
          hasPrivilege('dashboard_view_statistics') && user.type != 'reseller'
        "
        class="col-lg-6"
      >
        <div class="card h-100">
          <!-- <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <h5 class="m-0 me-2">
                {{ $t("dashboard.statistics.users") }}
              </h5>
            </div>
          </div> -->
          <div class="card-body row" style="height: 160px;">
            <div class="col-6">
              <h5>
                {{ $t("dashboard.statistics.online_admins") }}
                <span class="badge bg-label-success">{{
                  online_users.admins.count
                }}</span>
              </h5>
              <hr />
              <div
                v-for="(admin, index) in online_users.admins.emails"
                :key="index"
              >
                {{ admin }}
              </div>
            </div>
            <div class="col-6">
              <h5>
                {{ $t("dashboard.statistics.online_resellers") }}
                <span class="badge bg-label-success">{{
                  online_users.resellers.count
                }}</span>
              </h5>
              <hr />
              <div
                v-for="(admin, index) in online_users.resellers.emails"
                :key="index"
              >
                {{ admin }}
              </div>
            </div>
            <!-- <div id="OnlineUsers"></div> -->
          </div>
        </div>
      </div>
      <div
        v-if="
          hasPrivilege('dashboard_view_statistics') && user.type != 'reseller'
        "
        class="col-lg-6"
      >
        <div class="card h-100">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <div class="card-title mb-0">
              <h5 class="m-0 me-2">
                {{ $t("dashboard.statistics.top_10_profiles") }}
              </h5>
            </div>
          </div>
          <div class="card-body" style="height: 180px;">
            <div id="OnlineProfiles"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { hasPrivilege } from "../global_constants";

export default {
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      dash: {
        total_online: 0,
        disabled_accounts: 0,
        disabled_cards: 0,
        expiration_profile_accounts: 0,
        expired_accounts: 0,
        expiring_accounts: 0,
        managers: 0,
        online_accounts: 0,
        online_cards: 0,
        profiles: 0,
        support_tickets: 0,
        total_accounts: 0,
        total_cards: 0,
        total_debts: 0,
        total_users: 0,
        total_shamcash: 0,
        today_shamcash: 0,
      },
      online_users: {
        admins: { count: 0, percentage: 0, emails: [] },
        resellers: { count: 0, percentage: 0, emails: [] },
      },
      payments: {
        grand_total: 0,
        total_admins: 0,
        total_app: 0,
        total_me: 0,
        total_resellers: 0,
        total_shamcash: 0,
        total_admins_debt: 0,
        total_app_debt: 0,
        total_me_debt: 0,
        total_resellers_debt: 0,
        total_shamcash_debt: 0,
      },
      payments_loading: true,
      payments_filter: 'day',
      sessions: {
        online: 0,
        available: 100,
        remaining: 100,
      },
      sessions_interval: {
        interval: null,
        counter: 0,
      },
      nases: [],
    };
  },
  async created() {
    this.fetch_values();
    this.fetch_sessions();
    if (localStorage.getItem("server")) {
      await this.updateValues();
    }
  },
  async mounted() {
    await this.fetch_online_sessions_graph();
    await this.fetch_top_profiles_graph();
    await this.fetch_admins_graph();
    await this.fetch_payments();
    if (this.hasPrivilege("system_ownership")) {
      this.init_fetch_nases_api();
      this.sessions_interval.interval = setInterval(
        this.fetch_nases_api,
        20000,
      );
    }
  },
  unmounted() {
    if (this.sessions_interval.interval != null) {
      clearInterval(this.sessions_interval.interval);
      this.sessions_interval.interval = null;
    }
  },
  watch: {
    $route(newRoute, lastRoute) {
      if (this.sessions_interval.interval != null) {
        clearInterval(this.sessions_interval.interval);
        this.sessions_interval.interval = null;
      }
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetch_values() {
      const response = await axios.get("dash/users");
      if (response.status == 200) {
        this.dash = response.data.data;
      }
    },
    async fetch_sessions() {
      const response = await axios.get("settings/sessions");
      if (response.status == 200) {
        this.sessions = response.data.data;
      }
    },
    async fetch_payments() {
      this.payments_loading = true;
      const response = await axios.get(`dash/payments?filter=${this.payments_filter}`);
      if (response.status == 200) {
        this.payments = response.data.data;
        this.payments_loading = false;
      }
    },
    async updateValues() {
      if (!this.settings.ssr_auth_connected) {
        await this.$nextTick();
        this.$notify({
          title: this.$t("errors.license.auth_offline"),
          type: "error",
          duration: -1,
        });
      }
      var expire_days = Math.abs(
        moment().diff(this.settings.license.expires_at, "days"),
      );
      if (this.settings.license.expires_at != null && expire_days < 31) {
        await this.$nextTick();
        this.$notify({
          title: this.$t("errors.license.expiring", {
            days: expire_days,
          }),
          type: "warning",
          duration: -1,
        });
      }
      var remaining_percent =
        (this.settings.sessions.online * 100) /
        this.settings.sessions.available;
      if (remaining_percent >= 90 && this.settings.sessions.available > 0) {
        await this.$nextTick();
        this.$notify({
          title: this.$t("errors.license.expiring_sessions", {
            percent: remaining_percent,
          }),
          type: "warning",
          duration: -1,
        });
      }
      if (remaining_percent >= 99 && this.settings.sessions.available > 0) {
        await this.$nextTick();
        this.$notify({
          title: this.$t("errors.license.expired_sessions"),
          type: "error",
          closeOnClick: false,
          duration: -1,
        });
      }
      if (
        this.settings.license.expires_at != null &&
        moment()
          .add(-1, "days")
          .isAfter(this.settings.license.expires_at)
      ) {
        await this.$nextTick();
        this.$swal.fire({
          title: this.$t("errors.license.expired_title"),
          text: this.$t("errors.license.expired"),
          icon: "error",
          showCancelButton: false,
          showConfirmButton: false,
        });
        // this.$notify({
        //   title: this.$t("errors.license.expired"),
        //   type: "error",
        //   duration: -1,
        //   onClick: () => {
        //     console.log("License expired notification clicked");
        //   },
        // });
      }

      const update_status = await axios.get("settings/update/check");
      if (update_status.status == 200) {
        if (update_status.data.update == "yes") {
          await this.$nextTick();
          this.$swal
            .fire({
              title: this.$t("errors.update_available"),
              text: this.$t("errors.update_available_message"),
              icon: "info",
              showCancelButton: true,
              confirmButtonText: this.$t("control.update"),
              cancelButtonText: this.$t("control.cancel"),
              toast: true,
              reverseButtons: true,
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-label-secondary",
              },
              position: "bottom-end",
            })
            .then((result) => {
              if (result.isConfirmed) {
                localStorage.setItem("activeSystemTab", "updates");
                this.$router.push({ name: "Settings" });
              }
            });
        }
      }
    },
    async init_fetch_nases_api() {
      const response = await axios.get("dash/nases");
      if (response.status == 200) {
        this.nases = response.data.data;
        this.nases.forEach(async (nas) => {
          if (nas.api_connected) {
            nas.api_status_fail_count = 0;
          } else {
            nas.api_status_fail_count = 1;
          }
          if (nas.ping_connected) {
            nas.ping_status_fail_count = 0;
          } else {
            nas.ping_status_fail_count = 1;
          }
        });
      }
    },
    async fetch_nases_api() {
      if (this.sessions_interval.counter == 4) {
        clearInterval(this.sessions_interval.interval);
        this.sessions_interval.counter = 0;
        this.sessions_interval.interval = null;
        return;
      }
      const response = await axios.get("dash/nases");
      if (response.status == 200) {
        response.data.data.forEach(async (nas, index) => {
          if (!this.nases[index].api_connected) {
            this.nases[index].api_status_fail_count += 1;
            if (this.nases[index].api_status_fail_count == 3) {
              await this.$nextTick();
              this.$notify({
                title: this.$t("dashboard.api_disconnected"),
                text:
                  this.$t("dashboard.check_api_connection_with_network") +
                  ` ${nas.ip} ${nas.name}`,
                type: "warn",
                duration: -1,
              });
            }
          } else {
            this.nases[index].api_status_fail_count = 0;
          }
          if (!this.nases[index].ping_connected) {
            this.nases[index].ping_status_fail_count += 1;
            if (this.nases[index].ping_status_fail_count == 3) {
              await this.$nextTick();
              this.$notify({
                title: this.$t("dashboard.ping_timeout"),
                text:
                  this.$t("dashboard.check_connection_with_network") +
                  ` ${nas.ip} ${nas.name}`,
                type: "error",
                duration: -1,
              });
            }
          } else {
            this.nases[index].ping_status_fail_count = 0;
          }
        });
      }
      this.sessions_interval.counter += 1;
    },
    async fetch_online_sessions_graph() {
      await this.$nextTick();
      const chartEl = document.querySelector("#OnlineAccounts");
      const response = await axios.get("dash/online");

      const options = {
        series: [
          {
            name: this.$t("dashboard.statistics.session"),
            type: "area",
            data: response.data.data.sessions,
          },
        ],
        chart: {
          height: 160,
          type: "area",
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.4,
            opacityFrom: 0.6,
            opacityTo: 0,
            stops: [0, 95, 100],
          },
        },
        // markers: {
        //   size: 5,
        //   hover: { size: 6 },
        // },
        colors: ["#00cfe8"],
        xaxis: {
          categories: response.data.data.hours,
          labels: {
            show: true,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          min: 0,
          tickAmount: 4,
          labels: {
            formatter: (val) => `${val}`,
            style: {
              fontSize: "13px",
            },
          },
        },
        legend: {
          show: true,
          position: "bottom",
          fontSize: "14px",
          fontWeight: 500,
          markers: {
            width: 10,
            height: 10,
            radius: 12,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 4,
          },
          labels: {
            colors: "#5d596c",
            useSeriesColors: false,
          },
        },
        tooltip: {
          shared: true,
          x: { show: true },
          y: {
            formatter: (val) => `${val}`,
          },
        },
        grid: {
          strokeDashArray: 5,
        },
      };

      if (chartEl) {
        const chart = new ApexCharts(chartEl, options);
        chart.render();
      }
    },
    async fetch_top_profiles_graph() {
      await this.$nextTick();
      const chartEl = document.querySelector("#OnlineProfiles");
      const response = await axios.get("dash/profiles");
      const options = {
        series: [
          {
            name: this.$t("dashboard.statistics.online"),
            data: response.data.data.sessions,
          },
        ],
        chart: {
          type: "bar",
          height: 160,
          toolbar: { show: false },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 9,
            columnWidth: "80%",
          },
        },
        colors: ["#28C76F", "#28C76F"],
        xaxis: {
          categories: response.data.data.names,
          labels: {
            style: {
              fontSize: "12px",
            },
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}`,
            style: {
              fontSize: "12px",
            },
            show: true,
          },
        },
        grid: {
          strokeDashArray: 5,
        },
        tooltip: {
          // y: {
          //   formatter: (val) => this.formatTraffic(val),
          // },
        },
        dataLabels: {
          enabled: false,
          // formatter: (val) => this.formatTraffic(val),
        },
        legend: {
          show: false,
          position: "bottom",
          fontSize: "14px",
        },
      };

      if (chartEl) {
        const chart = new ApexCharts(chartEl, options);
        chart.render();
      }
    },
    async fetch_admins_graph() {
      await this.$nextTick();
      const chartEl = document.querySelector("#OnlineUsers");
      const response = await axios.get("dash/admins");
      this.online_users = response.data.data;
      // console.log(response.data.data);

      // const options = {
      //   series: [
      //     response.data.data.admins.count,
      //     response.data.data.resellers.count,
      //   ],

      //   chart: {
      //     type: "pie",
      //     height: 160,
      //     toolbar: { show: false },
      //     animations: {
      //       enabled: true,
      //       easing: "easeinout",
      //       speed: 800,
      //       animateGradually: {
      //         enabled: true,
      //         delay: 150,
      //       },
      //       dynamicAnimation: {
      //         enabled: true,
      //         speed: 350,
      //       },
      //     },
      //   },
      //   labels: [
      //     this.$t("dashboard.statistics.admins"),
      //     this.$t("dashboard.statistics.resellers"),
      //   ],
      //   colors: ["#7367F0", "#28C76F"],
      //   dataLabels: {
      //     enabled: false,
      //     formatter: (val) => `${val}%`,
      //   },
      //   legend: {
      //     show: false,
      //     position: "bottom",
      //     fontSize: "14px",
      //   },
      // };

      // if (chartEl) {
      //   const chart = new ApexCharts(chartEl, options);
      //   chart.render();
      // }
    },
  },
};
</script>
